import { HelpItemIdent } from "@coaching-culture/types";
import { PageHeader as BasePageHeader } from "@coaching-culture/ui";
import styled from "styled-components";
import { HelpItemButton } from "./HelpItemButton";

const PanelImage = styled.img`
  max-height: 80px;
`;

export type PageHeaderProps = {
  text: string;
  subtitle?: string;
  backUrl?: string;
  helpIdent?: HelpItemIdent;
  imageSrc?: any;
  /** Shown at the right: the page's actions. */
  children?: React.ReactNode;
};

/** The shared library PageHeader, plus the client's help button. */
export const PageHeader = ({
  text,
  subtitle,
  backUrl,
  helpIdent,
  imageSrc,
  children,
}: PageHeaderProps) => {
  const actions =
    imageSrc || children ? (
      <>
        {imageSrc && <PanelImage src={imageSrc} alt="" />}
        {children}
      </>
    ) : undefined;

  return (
    <BasePageHeader
      mb={5}
      title={text}
      description={subtitle}
      back={backUrl ? { to: backUrl } : undefined}
      titleAdornment={
        helpIdent && <HelpItemButton ident={helpIdent} style={{ top: 0 }} />
      }
      actions={actions}
    />
  );
};
